module.exports = {
      id: "euro-curacao-usage",
      viewBox: "0 0 47.8 47.8",
      url: __webpack_public_path__ + "img/symbols.b783b922d187f028e7dcd3736258c276.svg#euro-curacao",
      toString: function () {
        return this.url;
      }
    }